module.exports = __webpack_public_path__ + "img/stone.94d7f6ae.png";